import LanguageSelectionScreen from '@components/Header/LanguageSelectionScreen';
import { HeaderData } from '@components/Header/models';
import { FC, useState, useEffect } from 'react';
import AgencyProfileMobileMainScreen from './AgencyProfileMobileMainScreen';

const ScreenMapTypes = {
  main: {},
  language: {},
};
interface Props {
  isUserLoggedIn: boolean;
  marketplaceUrlPrefix: string;
  headerData?: HeaderData;
  language: string;
  pageName?: string;
  isLess1000View: boolean;
}

export type MobileHeaderScreenMapTypes = keyof typeof ScreenMapTypes;
export type SetActiveMobileScreenCb = React.Dispatch<
  React.SetStateAction<MobileHeaderScreenMapTypes>
>;

const MobileScreens: FC<Props> = ({
  isUserLoggedIn,
  marketplaceUrlPrefix,
  headerData = {
    keys: {},
    services: [],
    userData: {},
    userProfileImage: '',
  },
  language = 'en',
  pageName = 'explore',
  isLess1000View,
}) => {
  const [activeScreen, setActiveScreen] =
    useState<keyof typeof ScreenMapTypes>('main');

  useEffect(() => {
    if (!isLess1000View) {
      setActiveScreen('main');
    }
  }, [isLess1000View]);

  const onMobileMenuBack = () => {
    setActiveScreen('main');
  };

  const ScreenMap = (data: HeaderData) => ({
    main: (
      <AgencyProfileMobileMainScreen
        isUserLoggedIn={isUserLoggedIn}
        language={language}
        marketplaceUrlPrefix={marketplaceUrlPrefix}
        keys={headerData.keys}
        pageName={pageName}
        setActiveScreen={setActiveScreen}
      />
    ),
    language: (
      <LanguageSelectionScreen
        title={data?.keys?.mobileLanguageSelectionTitle}
        onBack={onMobileMenuBack}
        value={language}
        pageName={pageName}
      />
    ),
  });

  return ScreenMap(headerData)[activeScreen];
};

export default MobileScreens;
